import useGlobalSettings from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/useGlobalSettings.ts";
import Flex from "common/Boxes/Flex.tsx";
import Text from "common/Typography/Text.tsx";
import styled, { useTheme } from "styled-components";
import ExpandCollapse from "common/Animations/ExpandCollapse.tsx";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import MinusOutlined from "@ant-design/icons/MinusOutlined";
import MarginSelectors from "features/bots/BotForm/MultiSymbolMargin/MarginSelectors.tsx";
import React from "react";
import Tag from "common/Tags/Tag.tsx";
import { ContactWeb } from "common/Icons/Icons.tsx";

const GlobalSettings = () => {
  const theme = useTheme();
  const {
    globalSettingsExpanded,
    onExpandCollapseClick,
    globalSettingsPreview,
    isViewOnly,
  } = useGlobalSettings();

  return (
    <Wrapper>
      <Flex>
        <Flex>
          <ContactWeb
            style={{ marginRight: 6, color: theme.colors.secondaryText }}
          />
          <Text type="secondary">Global Settings</Text>
          <Tag
            color={theme.colors.primaryBlue}
            style={{ marginLeft: 8, whiteSpace: "nowrap" }}
          >
            {globalSettingsPreview}
          </Tag>
        </Flex>
        {!isViewOnly && (
          <IconsWrapper onClick={onExpandCollapseClick}>
            {globalSettingsExpanded ? <MinusOutlined /> : <PlusOutlined />}
          </IconsWrapper>
        )}
      </Flex>
      <ExpandCollapse expanded={globalSettingsExpanded}>
        <MarginSelectors isGlobalSettings={true} />
      </ExpandCollapse>
    </Wrapper>
  );
};

export default GlobalSettings;

const Wrapper = styled.div`
  padding: 16px 0;
  border-bottom: ${(p) => p.theme.borders.lightest};
`;
const IconsWrapper = styled.div`
  font-size: 18px;
  color: ${(p) => p.theme.colors.primaryBlue};
`;
